module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 217,
	"w": 250,
	"h": 310,
	"nm": "Catalogue",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Shape Layer 5",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 0,
							"s": [
								137.062,
								167.063,
								0
							],
							"to": [
								-3.333,
								-3.333,
								0
							],
							"ti": [
								3.333,
								3.333,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0,
								"y": 0
							},
							"t": 30,
							"s": [
								117.062,
								147.063,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 156,
							"s": [
								117.062,
								147.063,
								0
							],
							"to": [
								3.333,
								3.333,
								0
							],
							"ti": [
								-3.333,
								-3.333,
								0
							]
						},
						{
							"t": 186,
							"s": [
								137.062,
								167.063,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						98.072,
						98.072,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-42.477,
											-69.182
										],
										[
											-67.57,
											37.532
										],
										[
											-59.21,
											37.532
										],
										[
											-51.337,
											4.069
										],
										[
											-25.178,
											4.069
										],
										[
											-17.309,
											37.532
										],
										[
											-8.945,
											37.532
										],
										[
											-34.044,
											-69.182
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-38.26,
											-51.557
										],
										[
											-27.096,
											-4.07
										],
										[
											-49.424,
											-4.07
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											18.726,
											-36.626
										],
										[
											18.726,
											-28.487
										],
										[
											58.315,
											-28.487
										],
										[
											18.099,
											60.961
										],
										[
											18.099,
											69.182
										],
										[
											67.57,
											69.182
										],
										[
											67.57,
											61.042
										],
										[
											26.989,
											61.042
										],
										[
											67.241,
											-28.487
										],
										[
											67.57,
											-28.487
										],
										[
											67.57,
											-36.626
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-5.695,
											4.069
										],
										[
											26.867,
											4.069
										],
										[
											26.867,
											-4.071
										],
										[
											-5.695,
											-4.071
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.160784313725,
									0.282352941176,
									0.980392216701,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-19.142,
									-18.458
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 6,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": {
								"a": 0,
								"k": [
									182,
									242.24
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 16,
								"ix": 4
							},
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-16.697,
									-17.369
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 217,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Shape Layer 4",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 12,
							"s": [
								145.797,
								176.047,
								0
							],
							"to": [
								-3.333,
								-3.333,
								0
							],
							"ti": [
								3.333,
								3.333,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0,
								"y": 0
							},
							"t": 42,
							"s": [
								125.797,
								156.047,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 144,
							"s": [
								125.797,
								156.047,
								0
							],
							"to": [
								3.333,
								3.333,
								0
							],
							"ti": [
								-3.333,
								-3.333,
								0
							]
						},
						{
							"t": 174,
							"s": [
								145.797,
								176.047,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						98.072,
						98.072,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": {
								"a": 0,
								"k": [
									182,
									242.24
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 16,
								"ix": 4
							},
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-16.697,
									-17.369
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 217,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Shape Layer 3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 24,
							"s": [
								154.531,
								185.031,
								0
							],
							"to": [
								-3.333,
								-3.333,
								0
							],
							"ti": [
								3.333,
								3.333,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0,
								"y": 0
							},
							"t": 54,
							"s": [
								134.531,
								165.031,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 132,
							"s": [
								134.531,
								165.031,
								0
							],
							"to": [
								3.333,
								3.333,
								0
							],
							"ti": [
								-3.333,
								-3.333,
								0
							]
						},
						{
							"t": 162,
							"s": [
								154.531,
								185.031,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						98.072,
						98.072,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": {
								"a": 0,
								"k": [
									182,
									242.24
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 16,
								"ix": 4
							},
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-16.697,
									-17.369
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 217,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Shape Layer 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 36,
							"s": [
								163.266,
								194.016,
								0
							],
							"to": [
								-3.333,
								-3.333,
								0
							],
							"ti": [
								3.333,
								3.333,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0,
								"y": 0
							},
							"t": 66,
							"s": [
								143.266,
								174.016,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 120,
							"s": [
								143.266,
								174.016,
								0
							],
							"to": [
								3.333,
								3.333,
								0
							],
							"ti": [
								-3.333,
								-3.333,
								0
							]
						},
						{
							"t": 150,
							"s": [
								163.266,
								194.016,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						98.072,
						98.072,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": {
								"a": 0,
								"k": [
									182,
									242.24
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 16,
								"ix": 4
							},
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-16.697,
									-17.369
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 217,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 48,
							"s": [
								172,
								203,
								0
							],
							"to": [
								-3.333,
								-3.333,
								0
							],
							"ti": [
								3.333,
								3.333,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0,
								"y": 0
							},
							"t": 78,
							"s": [
								152,
								183,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 108,
							"s": [
								152,
								183,
								0
							],
							"to": [
								3.333,
								3.333,
								0
							],
							"ti": [
								-3.333,
								-3.333,
								0
							]
						},
						{
							"t": 138,
							"s": [
								172,
								203,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						98.072,
						98.072,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": {
								"a": 0,
								"k": [
									182,
									242.24
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 16,
								"ix": 4
							},
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-16.697,
									-17.369
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 217,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Catalogue.json
// module id = 40
// module chunks = 0